import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import { Controller } from 'react-hook-form';
import { StyledUiCheckbox } from './UiCheckbox.styles';

const UiCheckbox = ({ name, control, ...rest }) => {
  if (name && control)
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <StyledUiCheckbox>
            <Checkbox
              name={name}
              checked={field.value}
              color='primary'
              {...field}
              {...rest}
            />
          </StyledUiCheckbox>
        )}
      />
    );
  return (
    <StyledUiCheckbox>
      <Checkbox name={name} color='primary' {...rest} />
    </StyledUiCheckbox>
  );
};

UiCheckbox.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
};

export default UiCheckbox;
